export const TEXT_EDITOR_NAMESPACE = 'text-editor';

/**
 * Títulos de la barra, con su texto en inglés como clave (es lo que traduce Froala). Van por i18n porque Froala
 * no trae ca, vl, eu ni gl, y en los que trae hay errores («Itálito», «Más Rico»).
 */
export const TEXT_EDITOR_TOOLBAR_TITLES = [
  'Bold',
  'Italic',
  'Underline',
  'Font Size',
  'Clear Formatting',
  'Text Color',
  'Background Color',
  'Insert math expression',
  'Align Left',
  'Align Center',
  'Align Right',
  'Align Justify',
  'Ordered List',
  'Unordered List',
  'Decrease Indent',
  'Increase Indent',
  'Insert Link',
  'Insert Table',
  'Code View',
  'Undo',
  'Redo',
  'More Text',
  'More Paragraph',
  'More Rich',
  'More Misc',
] as const;

type FroalaLanguage = { translation: Record<string, string> };
type FroalaLanguages = Record<string, FroalaLanguage | undefined>;
type Translate = (key: string) => string;

/** Fichero de Froala para lo que no cubre i18n (popups): solo hay `es` y `pt_br`; el resto cae al español, como `fallbackLng`. */
export function getFroalaBaseLanguage(language: string | null | undefined): string | null {
  const baseLanguage = (language ?? '').split(/[-_]/)[0];

  if (baseLanguage === 'en') return null;
  if (baseLanguage === 'pt') return 'pt_br';
  return 'es';
}

/** Registra el idioma de la interfaz en `FroalaEditor.LANGUAGE`; si i18n no tiene la clave, se queda la traducción de Froala. */
export function registerTextEditorLanguage(languages: FroalaLanguages, language: string | null | undefined, t: Translate): string {
  const code = `tangerine_${language || 'default'}`;
  const baseCode = getFroalaBaseLanguage(language);
  const translation: Record<string, string> = { ...(baseCode ? languages[baseCode]?.translation : undefined) };

  TEXT_EDITOR_TOOLBAR_TITLES.forEach((title) => {
    const translatedTitle = t(`${TEXT_EDITOR_NAMESPACE}:${title}`);
    if (translatedTitle && translatedTitle !== title) translation[title] = translatedTitle;
  });

  languages[code] = { translation };
  return code;
}
